export default __webpack_public_path__ + "static/placeholder-6d7b23ad2775abd356c36dbcfbae26ed.webp";